import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { T_CustomerLobDetailObj } from "../../Feature_Login/Login_Types";
import { T_ApiResponse } from "../../../globalTypes/GlobalTypes";
import { StockLobCode } from "../../../utils/constants";
import { useCallback, useEffect, useReducer } from "react";
import { useLazyFetchPortfolioDataQuery } from "../Stockc&Securities_Api";
import { isEmpty } from "lodash";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import { AxiosError } from "axios";
import {
  Stocks_HandlingReducerAction,
  Stocks_ReduxInitialState,
} from "./Stocks_ReduxActionHandler";
import {
  setStocksDashboardDetails,
  setUserDetails,
} from "../Stocks&Securities_Slice";
import { T_LocalStocksBaseData } from "./Stocks_BaseData_Types";

export const UseStocksBaseDataLoader = (
  loadFor: "primary" | "secondary" = "primary",
  mobileNumber: string = ""
): T_LocalStocksBaseData => {
  const [localState, updateLocalState] = useReducer(
    Stocks_HandlingReducerAction,
    Stocks_ReduxInitialState
  );
  const dispatch = useAppDispatch();
  const csAppSlice = useAppSelector((st) => st.CsAppSlice);
  const userDetails = csAppSlice.userDetails;
  const stocksSlice = useAppSelector((st) => st.StocksSlice);
  const [fetchPortfolioData, { isFetching, error: errorInFetchPortFolioData }] =
    useLazyFetchPortfolioDataQuery();

  const customerAndLobDetails = userDetails?.customerAndLobDetails;
  const UserStocksLobId = customerAndLobDetails?.filter(
    (item: T_CustomerLobDetailObj) =>
      item.LOB === StockLobCode && item.PRIMARY_SECONDARY_USER === loadFor
  );

  const checkAndinitApiFlow = useCallback(() => {
    /** FN for Loading LI Dashboard Details */
    if (isEmpty(UserStocksLobId)) {
      updateLocalState({
        type: "error",
        payload: Error("Stocks lob id not present"),
      });
    } else if (
      isEmpty(stocksSlice.stockdashboardDetails) ||
      isEmpty(stocksSlice.CustomerData)
    ) {
      fetchPrimaryUserDashboardDetails();
    } else {
      updateLocalState({ type: "success", payload: "" });
    }
  }, [
    UserStocksLobId,
    stocksSlice.stockdashboardDetails,
    stocksSlice.CustomerData,
    mobileNumber,
  ]);

  /** FN for Loading LI Dashboard Details */
  const fetchPrimaryUserDashboardDetails = useCallback(async () => {
    if (isFetching) {
      return;
    }
    updateLocalState({ type: "fetching", payload: "" });
    const requestData = {
      MobileNo: mobileNumber,
      PanNo: "",
      RequestDate: new Date().toString(),
    };
    fetchPortfolioData(requestData).then(async (res) => {
      if (res.data?.code === API_STATUS_CODE.SUCCESS) {
        if (
          isEmpty(res.data.payload) ||
          isEmpty(
            res.data.payload[0].holdingDetailsList.result.NewDataset.Table1
          ) ||
          isEmpty(res.data.payload[0]?.customerData)
        ) {
          updateLocalState({ type: "error", payload: Error("Empty List") });
        } else {
          const portfolioData = res.data.payload;
          dispatch(
            setStocksDashboardDetails(
              portfolioData[0]?.holdingDetailsList.result.NewDataset.Table1 ||
                []
            )
          );
          dispatch(setUserDetails(portfolioData?.[0]?.customerData));
        }
      } else {
        updateLocalState({ type: "error", payload: Error("Empty List") });
      }
    });
  }, [isFetching, mobileNumber]);

  useEffect(() => {
    if (!isEmpty(mobileNumber)) {
      checkAndinitApiFlow();
    }
  }, [
    stocksSlice.stockdashboardDetails,
    stocksSlice.CustomerData,
    mobileNumber,
  ]);

  useEffect(() => {
    if (errorInFetchPortFolioData) {
      updateLocalState({
        type: "error",
        payload: (errorInFetchPortFolioData || Error("api failed")) as Error,
      });
    }
  }, [errorInFetchPortFolioData]);

  return localState;
};
